import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  accountNumber,
  apiKey,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, apiKey] as const
const locationCredentialTypes = ['irv', accountNumber] as const

export type pitdCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const pitdDocumentTypes = [
  'customs-documents',
  'dimension-certificate',
  'inspection-certificate',
  'packing-slip',
  'partner-bill-of-lading',
  'proof-of-delivery',
  'signed-bol',
  'volume-certificate',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const pitd: CarrierDef<pitdCredType> = {
  name: 'Pitt Ohio',
  scac: 'pitd',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    { id: 'volume', name: 'Volume' },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['account-number', 'ref1'],
    ['irv', 'ref2'], // CRED NOTE - I think poseidon is the only one using ref2/irv.  In core ref2 comes from the root api key, wondering if we need the additional field
  ],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'profinder',
    'documents',
    'tracking',
  ],
  documentTypes: pitdDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
    username: { nonsensitive: true },
  },
}
